module.exports = __webpack_public_path__ + "img/ico_top_arrow_disabled.07635644.svg";